<template>
    <list-cell-text>
        <template #icons="{ bindings }">
            <svg-icon
                :size="bindings.iconSize"
                :icon="IconCreatedAt"
                :color="Color.gray400"
            />
            <svg-icon
                :size="bindings.iconSize"
                :icon="IconUpdatedAt"
                :color="Color.gray400"
            />
        </template>

        <template #content>
            <text-decorator :size="FontSize.sm">
                {{ formattedCreatedAt }}
            </text-decorator>

            <text-decorator :size="FontSize.sm" :color="Color.gray400">
                {{ formattedUpdatedAt }}
            </text-decorator>
        </template>
    </list-cell-text>
</template>

<script setup lang="ts">
    import { Color, FontSize, ListCellText, SvgIcon, TextDecorator } from '@keyvue/one-ui';
    import { computed } from 'vue';

    import IconCreatedAt from '@keyvue/one-material-icons/icons/login.svg?component';
    import IconUpdatedAt from '@keyvue/one-material-icons/icons/autorenew.svg?component';
    import { formatDate } from '@/utils/date';

    const props = defineProps<{
        createdAt: Date | string,
        updatedAt: Date | string,
    }>();

    const formattedCreatedAt = computed(() => formatDate(new Date(props.createdAt)));
    const formattedUpdatedAt = computed(() => formatDate(new Date(props.updatedAt)));
</script>
